import React from 'react'

const CardTitle = ({ children, className = '', id }) => (
  <div className={`g-cardtitle ${className}`} id={id}>
    {children}
  </div>
)

export default CardTitle
